import { firstOf, secondOf } from 'utils/arrays/elements.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';

const fromNameValueToArray = (dto) => [fromAnyToTrimmed(dto?.name), fromAnyToTrimmed(dto?.value)];
const fromArrayToObject = (dto) => fromEntriesToObject(dto.map(fromNameValueToArray));
const stringifyKeyVal = (entry) => [fromAnyToTrimmed(firstOf(entry)), fromAnyToTrimmed(secondOf(entry))];
const byValidEntry = (entry) => fromAnyToBool(firstOf(entry) || secondOf(entry));

// SEE: https://github.com/getslick/api.core/blob/staging/docs/CustomPermissions.md
const fromStylistPermissionsToDto = (dto) => {
  // first check if we get an array or an object
  const perms = Array.isArray(dto) ? fromArrayToObject(dto) : dto ?? {};

  // then make sure the key/value pairs are all strings and remove those missing one or the other
  const filtered = fromEntriesToObject(fromObjectToEntries(perms).map(stringifyKeyVal).filter(byValidEntry));

  // now just structure it correctly and return it back
  return { custom_permissions: filtered };
};

export default fromStylistPermissionsToDto;
